$(function () {
  $(".fw-gallery").on("init", function (event, slick) {
    $(".slick-dots button").html("&bull;");
  });

  $(".fw-gallery").slick({
    arrows: false,
    infinite: false,
    dots: true,
    centerMode: true,
    fade: false,
    slidesToShow: 3,
    focusOnSelect: true,
    centerPadding: "100px",
    cssEase: "ease",
    responsive: [
      {
        breakpoint: 2400,
        settings: {
          centerPadding: "120px",
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 2000,
        settings: {
          centerPadding: "700px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1750,
        settings: {
          centerPadding: "450px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          centerPadding: "350px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          centerPadding: "200px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          centerPadding: "150px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 750,
        settings: {
          centerPadding: "100px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 580,
        settings: {
          centerPadding: "75px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: "50px",
          slidesToShow: 1,
        },
      },
    ],
  });

  $(document).on("keydown", function (e) {
    var code = e.key ? e.key : e.which;
    if (code === "ArrowLeft") {
      $(".slick-arrow").each(function () {
        $(this).trigger("blur");
      });
      $(".fw-gallery").slick("slickPrev");
    } else if (code == "ArrowRight") {
      $(".slick-arrow").each(function () {
        $(this).trigger("blur");
      });
      $(".fw-gallery").slick("slickNext");
    }
  });

  $(".fw-gallery").on("mousedown", () => {
    $(".fw-gallery").removeClass("cursor-grab");
    $(".fw-gallery").addClass("cursor-grabbing");
  });

  $(".fw-gallery").on("mouseup", () => {
    $(".fw-gallery").removeClass("cursor-grabbing");
    $(".fw-gallery").addClass("cursor-grab");
  });
});

var dropdown = document.querySelectorAll(".cheader-menu__dropdown .dropbtn");
var i;

for (i = 0; i < dropdown.length; i++) {
  dropdown[i].addEventListener("click", function (e) {
    e.currentTarget.classList.toggle("active");
    var dropdownContent = e.currentTarget.nextElementSibling;
    if (dropdownContent.style.display === "block") {
      dropdownContent.style.display = "none";
    } else {
      dropdownContent.style.display = "block";
    }
  });
}
